import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const notify = (msg) => {
  toast.error(msg, {
    position: "bottom-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
  toast.clearWaitingQueue();
};
export const AuthErrorMessages = (errorCode) => {
  switch (errorCode) {
    case "auth/captcha-expired":
      notify("Captcha Expired! Please Refresh!");
      break;

    case "auth/user-not-found":
      notify("User not found");
      break;

    case "auth/operation-not-allowed":
      notify("Operation not allowed");
      break;

    case "auth/invalid-display-name":
      notify("Invalid display name");
      break;

    case "camp/camp-error":
      notify("Error in creating/duplicating campaign");
      break;

    case "template/template-error":
      notify("Error in creating Template. Try Again!");
      break;
    //
    case "auth/invalid-password":
      notify("Invalid password");
      break;

    case "auth/wrong-password":
      notify("Wrong password");
      break;

    case "auth/invalid-email":
      notify("Invalid email");
      break;

    case "auth/invalid-credential":
      notify("Invalid credential");
      break;

    case "auth/internal-error":
      notify("Internal error");
      break;

    case "auth/email-already-exists":
      notify("Email already exists");
      break;

    case "auth/email-already-in-use":
      notify("Email already in use");
      break;

    case "auth/invalid-code":
      notify("Invalid Code");
      break;

    case "auth/passwords-not-matched":
      notify("Password not matched");
      break;

    case "auth/phone-number-already-exists":
      notify("Phone number is already in use");
      break;

    case "auth/invalid-verification-code":
      notify("Invalid code");
      break;

    case "auth/code-expired":
      notify("Code Expired");
      break;

    case "auth/too-many-requests":
      notify("Too many requests");
      break;

    case "client/creation-error":
      notify("Error creating client");
      break;
    case "deal/creation-error":
      notify("Error creating/updating deal");
      break;
    case "appointment/creation-error":
      notify("Error creating an appointment");
      break;
    case "client/unable-to-send-email":
      notify("Unable to send email");
      break;

    default:
      notify("Unknown Error");
      break;
  }
};
export const info = (msg) => {
  toast.info(msg, {
    position: "bottom-center",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
  toast.clearWaitingQueue();
};
export const ToastInfoMessages = (infoCode) => {
  switch (infoCode) {
    case "phone/code-resend-successfully":
      info("Code resend successfully");
      break;

    case "email/code-resend-successfully":
      info("Invite resend successfully");
      break;

    default:
      info("Unknown Error");
      break;
  }
};

const success = (msg) => {
  toast.success(msg, {
    position: "bottom-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  });
  toast.clearWaitingQueue();
};
export const ToastSuccessMessages = (infoCode) => {
  switch (infoCode) {
    case "agent/creation-successful":
      success("Agent created successfully");
      break;
    case "deal/creation-successful":
      success("Deal created/updated successfully");
      break;
    case "camp/camp-successful":
      success("Campaign Created/Duplicated successfully");
      break;
    case "template/template-successful":
      success(
        "Template Created successfully, Refresh design page on create campaign"
      );
      break;
    case "agent/updating-successful":
      success("Agent updated successfully");
      break;

    case "lead/creation-successful":
      success("Client created successfully");
      break;

    case "lead/updating-successful":
      success("Client updated successfully");
      break;

    case "email/resend-successful":
      success("Email dispatched");
      break;

    case "email/resend-email-successful":
      success("Code resend successfully on your email");
      break;

    case "email/email-updated":
      success("Email is updated successfully");
      break;

    case "otp/resend-successful":
      success("OTP resend successfully");
      break;

    case "appointment/creation-successful":
      success("Appointment created successfully");
      break;

    case "appointment/updation-successful":
      success("Appointment updated successfully");
      break;

    default:
      info("Unknown Error");
      break;
  }
};
